export default {
  name: 'Default',
  icon: 'mdi-help-circle-outline',
  label: 'Default',
  showInMenu() {
    return false;
  },
};
